import React from 'react';
import ReactDOM from 'react-dom/client';
import Web3 from 'web3';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Web3ReactProvider } from '@web3-react/core';
import { MetaMaskProvider } from './hooks/metamask';

import '../src/assets/css/bootstrap.min.css';
import '../src/assets/css/bootstrap-grid.min.css';
import '../src/assets/css/bootstrap-reboot.min.css';
import '../src/assets/css/animate.css';
import '../src/assets/css/owl.carousel.css';
import '../src/assets/css/owl.theme.css';
import '../src/assets/css/owl.transitions.css';
import '../src/assets/css/magnific-popup.css';
import '../src/assets/css/jquery.countdown.css';
import '../src/assets/css/style.css';
import '../src/assets/css/colors/scheme-02.css';
import '../src/assets/css/coloring.css';
import '../src/assets/css/style.css';
import { Provider } from 'react-redux';
import store from './store';

const getLibrary = (provider, connector) => {
    return new Web3(provider);
};

ReactDOM.createRoot(document.getElementById('wrapper')).render(
    // <React.StrictMode>
    <Web3ReactProvider getLibrary={getLibrary}>
        <MetaMaskProvider>
            <Provider store={store}>
                <App />
            </Provider>
        </MetaMaskProvider>
    </Web3ReactProvider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
